module.exports = __webpack_public_path__ + "img/核心技术--表情识别.c4ed486d.png";